module.exports = __webpack_public_path__ + "assets/img/gar5-3.5ce12c4f.jpg";